import Vue from 'vue';

Vue.component('tail-modal', require("./Modal.vue").default);
Vue.component('tail-modal-show', require("./ModalShow.vue").default);
Vue.component('tail-breadcrum', require("./Breadcrum.vue").default);
Vue.component('tail-base-layout', require("./BaseLayout.vue").default);
Vue.component('tail-card', require("./Card.vue").default);
Vue.component('data-table', require("./DataTable.vue").default);
Vue.component('tail-select', require("./SelectFormField.vue").default);
Vue.component('tail-patient-details', require("./PatientDetails.vue").default);
Vue.component('tail-drug-select', require("./DrugSelect.vue").default);
Vue.component('tail-vitals-details', require("./VitalsDetails.vue").default);
Vue.component('tail-address-header', require("./AddressHeader.vue").default);
Vue.component('tail-switch', require("./Switch.vue").default);
Vue.component('tail-action-buttons', require("./ActionDropdown.vue").default);
Vue.component('tail-stamp', require("./stamp.vue").default);
Vue.component('tail-stamp-right', require("./stamp-right.vue").default);
Vue.component('tail-signature', require("./Signature.vue").default);
